import { render, staticRenderFns } from "./NewsBW2026Fukuoka.vue?vue&type=template&id=7a51642c&scoped=true&"
import script from "./NewsBW2026Fukuoka.vue?vue&type=script&lang=js&"
export * from "./NewsBW2026Fukuoka.vue?vue&type=script&lang=js&"
import style0 from "./NewsBW2026Fukuoka.vue?vue&type=style&index=0&id=7a51642c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51642c",
  null
  
)

export default component.exports